import AnimatedDropDownFund from './AnimatedDropDownFund';

export default AnimatedDropDownFund;
